import React from 'react';
import { PageSectionContent, PageSectionWrapper } from './styles';

export const PageSection: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IPageSectionProps>>
> = props => {
  return (
    <PageSectionWrapper
      className={props.className}
      recessed={props.recessed}
      noBorder={props.noBorder}
    >
      <PageSectionContent noPad={props.noPad}>
        {props.children}
      </PageSectionContent>
    </PageSectionWrapper>
  );
};

interface IPageSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  recessed?: boolean;
  noPad?: 'bottom' | 'top' | 'both';
  noBorder?: boolean;
}
